import { change as formChange } from 'redux-form';
import { dispatch } from '../../../store/store';

const change = (formId, fields) => {
  if (!formId || !fields) return;

  Object.keys(fields).forEach(fieldId => {
    const value = fields[fieldId];
    if (value === null) return;

    dispatch(formChange(formId, fieldId, value));
  });
};

const FormActions = {
  change
};

export default FormActions;



// WEBPACK FOOTER //
// ./src/store/forms/utils/formActions.js